export const addProtocolToUrl = url => {
  if (!url) return '';

  if (!/^https?:\/\//i.test(url)) {
    return 'https://' + url;
  }

  return url;
};
